import { Text } from 'grommet';
import React from 'react';
import useSWR from 'swr';
import { silentFetcher } from '../utils/errors';
import { formatName } from '../utils/names';

const CustomerLabel = ({customerId, ...props}) => {
    const { data } = useSWR(
        customerId ? `/api/customers/${customerId}` : undefined,
        silentFetcher,
        {
            revalidateOnFocus: false
        },
    );

    return data ? (
        <Text {...props}>
            {data?.company_name || formatName(data, true)}
        </Text>
    ) : (<></>);
}

export default CustomerLabel;